import { useEffect, useRef } from "react";

export function useInterval(callback: () => void, delayMs: number) {
    const savedCallback = useRef<typeof callback>();

    // Remember the latest callback.
    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    // Call incoming function when component have been initialized.
    useEffect(() => {
        callback();
    }, []);

    // Set up the interval.
    useEffect(() => {
        function tick() {
            savedCallback.current();
        }
        if (delayMs !== null) {
            const id = setInterval(tick, delayMs);
            return () => clearInterval(id);
        }
    }, [delayMs]);
}
